module.exports = __webpack_public_path__ + "static/aida-logo-2b0abae04b9ff790e3fca6959071ef35.png";